/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAwsCustomLensQuestion {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAwsCustomLensQuestion.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAwsCustomLensQuestion>): WellArchitectedFrameworkAwsCustomLensQuestion {
        let obj = Object.assign(new WellArchitectedFrameworkAwsCustomLensQuestion(), model);
        WellArchitectedFrameworkAwsCustomLensQuestion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAwsCustomLensQuestion>): WellArchitectedFrameworkAwsCustomLensQuestion {
        if (!model) return null;
        return WellArchitectedFrameworkAwsCustomLensQuestion.newInstance(<WellArchitectedFrameworkAwsCustomLensQuestion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAwsCustomLensQuestion) {
        if (!obj) return;

        models.WellArchitectedFrameworkAwsCustomLensQuestion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAwsCustomLensQuestion): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAwsCustomLensQuestion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.choices) {
            for (let val of this.choices) {
                models.WellArchitectedFrameworkAwsCustomLensChoice.fixupPrototype(val);
            }
        }
        if (this.risk_rules) {
            for (let val of this.risk_rules) {
                models.WellArchitectedFrameworkAwsCustomLensRiskRule.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of question associated with AWS custom lens
     */
    sys_id: string;

    /**
     * Title of question associated with AWS custom lens
     */
    title: string;

    /**
     * Description of question associated with AWS custom lens
     */
    description: string;

    /**
     * Choices associated with AWS custom lens
     */
    choices: Array<models.WellArchitectedFrameworkAwsCustomLensChoice>;

    /**
     * Risk rule associated with AWS custom lens
     */
    risk_rules: Array<models.WellArchitectedFrameworkAwsCustomLensRiskRule>;

}
